import { type ReactElement, type ReactNode } from 'react';
import { AddDialog } from '@/components/AddDialog';
import { DialogFormBody, DialogInlineCode, Text } from '@/ui';

export const editDialogInputBackgroundColor = 'var(--surface-page)' as const;

type EntityEditDialogProps = {
  open: boolean;
  entityLabel: string;
  entityName: string;
  entityRunNumber?: number | null;
  saving?: boolean;
  disableSave?: boolean;
  saveLabel?: string;
  errorMessage?: string | null;
  onClose: () => void;
  onSave: () => void | Promise<void>;
  children: ReactNode;
};

export const EntityEditDialog = ({
  open,
  entityLabel,
  entityName,
  entityRunNumber,
  saving = false,
  disableSave = false,
  saveLabel = 'Save',
  errorMessage,
  onClose,
  onSave,
  children,
}: EntityEditDialogProps): ReactElement => {
  const resolvedEntityName = entityName.trim() || `this ${entityLabel.toLowerCase()}`;
  const resolvedEntityRunLabel =
    entityRunNumber !== null && entityRunNumber !== undefined
      ? `${resolvedEntityName} #${String(entityRunNumber)}`
      : resolvedEntityName;

  return (
    <AddDialog
      open={open}
      title={`Edit ${entityLabel}`}
      saving={saving}
      disableSave={disableSave}
      saveLabel={saveLabel}
      description={
        <Text role="body" color="textSecondary">
          Update details for <DialogInlineCode>{resolvedEntityRunLabel}</DialogInlineCode>.
        </Text>
      }
      errorMessage={errorMessage}
      onClose={onClose}
      onSave={onSave}
    >
      <DialogFormBody>{children}</DialogFormBody>
    </AddDialog>
  );
};
